import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Committee from './pages/Committee';
import FoundationMembers from './pages/FoundationMembers';
import Education from './pages/Education';
import Programs from './pages/Programs';
import Sports from './pages/Sports';
import Environment from './pages/Enivronment';
import SocialWelfare from './pages/SocialWelfare';
import Gallery from './pages/Gallery';
import Articles from './pages/Articles';
import AnnualReports from './pages/AnnualReports';
import BecomeMember from './pages/BecomeMember';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-team" element={<Committee />} />
        <Route path="/committee" element={<Committee />} />
        <Route path="/foundation-members" element={<FoundationMembers />} />
        <Route path="/become-member" element={<BecomeMember />} />
        <Route path="/education" element={<Education />} />
        <Route path="/sports" element={<Sports />} />
        <Route path="/environment" element={<Environment />} />
        <Route path="/welfare" element={<SocialWelfare />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/annual-reports" element={<AnnualReports />} />
        <Route path="/programs" element={<Programs />} />
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
